import { VStack, Text, Tr, Spinner, Td, Button } from "@chakra-ui/react";
import { useMemo, useRef } from "react";
import {
  useClearRefinements,
  useCurrentRefinements,
  useInfiniteHits,
  useInstantSearch,
  useSearchBox,
} from "react-instantsearch";
import { labelForStatus } from "./EventFilters";
import { KYDAdminEventSummary } from "@common/interfaces/KYDEvent";

const LoadingEmptyResults = () => {
  const { status } = useInstantSearch();
  const { query, refine } = useSearchBox();
  const { items: refinements } = useCurrentRefinements();

  const { refine: clearRefinements } = useClearRefinements({
    includedAttributes: ["status"],
  });

  const { items } = useInfiniteHits<KYDAdminEventSummary>({
    escapeHTML: false,
    showPrevious: false,
  });

  const statusRefinement = useMemo(() => {
    const status = refinements.find((r) => r.attribute === "status");

    if (!status) return "ALL";

    return (
      (status.refinements.find((r) => r.attribute === "status")
        ?.value as string) || "ALL"
    );
  }, [refinements, query]);

  const clearFilters = () => {
    if (statusRefinement === "ALL") {
      clearRefinements();
      refine("");
    } else {
      clearRefinements();
    }
  };

  return (
    <>
      {status === "loading" ? (
        <Tr>
          <Td colSpan={6}>
            <VStack>
              <Spinner />
              <Text>Loading events...</Text>
            </VStack>
          </Td>
        </Tr>
      ) : status === "idle" && items.length === 0 ? (
        <Tr>
          <Td colSpan={6}>
            <VStack w="full">
              <Text w="full" textAlign="center" py={4}>
                No events found with status{" "}
                <Text as="span" fontWeight="bold">
                  {labelForStatus(statusRefinement)?.toLowerCase()}
                </Text>
              </Text>
              <Button onClick={() => clearFilters()}>Clear filters</Button>
            </VStack>
          </Td>
        </Tr>
      ) : null}
    </>
  );
};

export default LoadingEmptyResults;
